import style from "./Button.module.scss";

export function ButtonEE({ children }: any) {
  return <button className={style.redButton}>{children}</button>;
}
